import { ethereum } from '@0xtorch/core'
import { katana } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createKatanaChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createKatanaChainCustom({
    client: createClient({
      chain: katana,
      httpRpcs: katanaHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'KatanaScan',
      baseUrl: 'https://katanascan.com',
      chainId: 747_474,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateKatanaChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createKatanaChainCustom = ({
  client,
  explorer,
}: CreateKatanaChainCustomParameters): Chain => ({
  id: 747_474,
  network: 'katana',
  name: 'Katana',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0xee7d8bcfb72bc1880d0cf19822eb0a2e6577ab62',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'katana',
  defillamaId: undefined,
})

export const katanaHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.katana.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const katanaWebsocketRpcUrls: string[] = []
